/**
 * Shopify Ajaxify Shop.
 *
 * @uses Modified Shopify jQuery API (link to it)
 *
 */

jQuery(document).ready(function() {
//Begin Wrapper

var jQ = jQuery;
Shopify.money_format = "&pound;{{amount}}";

/**
 * Collection of Selectors for various pieces on the page we need to update
 *
 * I've tried to keep these as general and flexible as possible, but
 * if you are doing your own markup, you may find you need to change some of these.
 *
 */
var selectors = {
  // Any elements(s) with this selector will have the total item count put there on add to cart.
  CART_HEADER: '.cart-header',
  TOTAL_ITEMS: '.cart-total-items',
  TOTAL_PRICE: '.cart-total-price',

  SUBMIT_ADD_TO_CART: 'input[type=image], input.submit-add-to-cart',

  FORM_ADD_TO_CART: 'form[action*="/cart/add"]',

  FORM_UPDATE_CART: 'form[id=cartform]',
  //The actual Update Button
  FORM_UPDATE_CART_BUTTON: 'form[id=cartform] input[name=update]',
  //All the buttons on the form
  FORM_UPDATE_CART_BUTTONS: 'input[type=image], input.button-update-cart',

  LINE_ITEM_ROW: '.cart-line-item',
  LINE_ITEM_QUANTITY_PREFIX: 'input#updates_',
  LINE_ITEM_PRICE_PREFIX: '.cart-line-item-price-',

  LINE_ITEM_REMOVE: '.remove a',

  CART_MESSAGE: '#cart-message'
};


/**
 * Collection of text strings.
 *
 */
var text = { ITEM: 'Item', ITEMS: 'Items' };




$(selectors.FORM_ADD_TO_CART).submit(function(e) {
  var button = $(this).find(selectors.SUBMIT_ADD_TO_CART);
  var outerWidth = button.outerWidth();

  //Disable the Add To Cart button, add a disabled class.
  button
    .attr('disabled', true)
    .addClass('disabled')
    .css({ 'width': outerWidth })
    .val("Adding...");

  // add to cart and show message in callback
  Shopify.addItemFromForm(
    $(this).attr('id'),
    function(line_item){

      Shopify.getCart();

      // scroll to top and  show update cart message
      $('html, body').animate({
        scrollTop: $('html').offset().top
      }, 200, function(){
        var cart_message = $(selectors.CART_MESSAGE);
        var cart_message_html = '<span class="added"><a href="/cart">Added to Cart</a></span>';

        if (cart_message){
          cart_message
            .html(cart_message_html)
            .css('opacity', 0)
            .removeClass('hide')
            .animate({ opacity: 1 }, 200, function(){
              window.setTimeout(function() {
                $(selectors.CART_MESSAGE).empty().addClass('hide');
              }, 2200);
            });
        }

      });
      
      // CLEANUP

      // clear cart errors
      $(selectors.FORM_ADD_TO_CART).find('.message').addClass('hide').empty();

      reset_add_to_cart_button();

    }
  );

  return false;
});

//We only want to interrupt the UPDATE, not the CHECKOUT process
//$(selectors.FORM_UPDATE_CART_BUTTON).click(function(e) {
  //$(e.target.form)
    //.find(selectors.FORM_UPDATE_CART_BUTTONS)
    //.attr('disabled', true)
    //.addClass('disabled');

  //Shopify.updateCartFromForm($(this).parents('form').attr('id'));

  //return false;
//});

//Delegate the Remove Link functionality on the cart page.
$(selectors.FORM_UPDATE_CART).delegate(selectors.LINE_ITEM_REMOVE, 'click', function(e) {
  //Get the variant ID from the URL
  var vid = this.href.split('/').pop().split('?').shift();
  Shopify.removeItem(vid);
  $(this).parents(selectors.LINE_ITEM_ROW).remove();

  return false;
});




reset_add_to_cart_button = function(){
  // find the add to cart button
  $(selectors.FORM_ADD_TO_CART)
    .find(selectors.SUBMIT_ADD_TO_CART)
    .attr('disabled', false)
    .removeClass('disabled')
    .val("Add to Cart");
};





Shopify.onError = function(XMLHttpRequest, textStatus) {
  // Shopify returns a description of the error in XMLHttpRequest.responseText. JSON.
  // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
  var data = eval('(' + XMLHttpRequest.responseText + ')');

  if (!!data.message) {
    display_error(data);
  }
};

display_error = function(error_data) {

  // add to cart error: sold out
  if (error_data.status == 422){
    var message_container = $(selectors.FORM_ADD_TO_CART).find('.message');
    var message_html = "<p><small>"+ error_data.description +"</small></p>";

    message_container
      .addClass('error')
      .removeClass('hide')
      .html(message_html);

    reset_add_to_cart_button();

    // $(selectors.SUBMIT_ADD_TO_CART).val('Unavailable');

    // window.setTimeout(function() {
    //   message_container.addClass('hide').empty();
    // }, 3000);
  }

}

/**
 * Shopify.onItemAdded
 *
 * Triggered by the response when something is added to the cart via the add to cart button.
 * This is where you would want to put any flash messaging, for example.
 *
 * @param object line_item
 * @param HTMLelement/String Form HTMLElement, or selector
 */
// Shopify.onItemAdded = function(line_item, form) {
//   //Default behaviour for this modification:
//   //Get the state of the cart, which will trigger onCartUpdate
//   Shopify.getCart();
// };

/**
 * This updates the N item/items left in your cart
 *
 * It's setup to match the HTML used to display the Cart Count on Load. If you change that (in your theme.liquid)
 * you will probably want to change the message html here.
 * This will update the HTML in ANY element with the class defined in selectors.TOTAL_ITEMS
 *
 * @param object the cart object.
 * @param HTMLElement form. If included, we know its an Update of the CART FORM, which will trigger additional behaviour.
 */
Shopify.onCartUpdate = function(cart, form) {
  // Total Items Update
  var cart_status = 'View Cart (<span class="cart-total-items">'+cart.item_count+'</span> ' + ((cart.item_count == 1) ? text.ITEM : text.ITEMS ) + ') ';
  if ((typeof Currency === 'object') && (typeof Currency.convertAll === 'function')) {
    // If there has been some conversion done on the page already.
    cart_status += '<span class="cart-total-price">' + Shopify.formatMoney(Currency.convert(cart.total_price, Shopify.currency, Currency.currentCurrency), Currency.money_with_currency_format[Currency.currentCurrency]) + '</span>';
  } else {
    cart_status += '<span class="cart-total-price">' + Shopify.formatMoney(cart.total_price) + '</span>';
  }
  $(selectors.CART_HEADER).html(cart_status);


  // A form was passed in?
  form = form || false;

  //so it's the cart page form update, trigger behaviours for that page
  if(form) {
    //Nothing left in cart, we reveal the Nothing in cart content, hide the form.
    if(cart.item_count > 0) {
      //Loops through cart items, update the prices.
      jQ.each(cart.items, function(index, cartItem) {
        if ((typeof Currency === 'object') && (typeof Currency.convertAll === 'function')) {
          // If there has been some conversion done on the page already.
          $(selectors.LINE_ITEM_PRICE_PREFIX + cartItem.id).html(Shopify.formatMoney(Currency.convert(cart.total_price, Shopify.currency, Currency.currentCurrency), Currency.money_with_currency_format[Currency.currentCurrency]));
        } else {
          $(selectors.LINE_ITEM_PRICE_PREFIX + cartItem.id).html(Shopify.formatMoney(cartItem.line_price));
        }
        $(selectors.LINE_ITEM_QUANTITY_PREFIX + cartItem.id).val(cartItem.quantity);
      });

      //And remove any line items with 0
      $(form).find('input[value=0]').parents(selectors.LINE_ITEM_ROW).remove();

      //Since we are on the cart page, reenable the buttons we disabled
      $(form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', false).removeClass('disabled');
    }
    //You can add any extra messaging you would want here.
    //successMessage('Cart Updated.');
  }
};

//End Wrapper
});

